<template>
  <Page class="page-rnr-person-file" :title="convertLanage('文件信息')">
    <template #slot-title>
      <span>{{ currentFlow }}/{{ totalFlow }}</span>
      <span>{{ convertLanage('文件信息') }}</span>
    </template>
    <template #slot-before-main>
      <div class="page-rnr-person-file-tip">
        {{ convertLanage('文件类型为图片文件，允许支持的照片格式包括bmp、jpg/jpeg、png，小于500K。（购车合同、购车发票、行驶证、过户证明无需全部提供，任选一种上传即可。）') }}
      </div>
    </template>
    <div class="page-rnr-main-card">
      <ErrorWrap :error-message="inputError.purchaseContractPic" :error="!!inputError.purchaseContractPic">
        <van-cell id="purchaseContractPic" :required="true" :title="convertLanage('购车合同')" class="van-field">
          <template #label>
            <BridgeUpload v-model="formData.purchaseContractPic" :customer="true">
              <div class="page-rnr-main-card-upload-normal">
                <div class="icon-upload-camera" />
              </div>
            </BridgeUpload>
          </template>
        </van-cell>
      </ErrorWrap>
    </div>
    <div class="page-rnr-main-card">
      <ErrorWrap>
        <van-cell id="contractPic" :title="convertLanage('购车发票或行驶证之一')" class="van-field">
          <template #label>
            <BridgeUpload v-model="formData.purchaseInvoicePic" :customer="true">
              <div class="page-rnr-main-card-upload-normal">
                <div class="icon-upload-camera" />
              </div>
            </BridgeUpload>
          </template>
        </van-cell>
      </ErrorWrap>
    </div>
    <div class="page-rnr-main-card">
      <ErrorWrap :error-message="inputError.transferCertificatePic" :error="!!inputError.transferCertificatePic">
        <van-cell id="contractPic" :title="convertLanage('过户证明')" class="van-field">
          <template #label>
            <BridgeUpload v-model="formData.transferCertificatePic" :customer="true">
              <div class="page-rnr-main-card-upload-normal">
                <div class="icon-upload-camera" />
              </div>
            </BridgeUpload>
          </template>
        </van-cell>
      </ErrorWrap>
    </div>
    <template #slot-operation>
      <van-button class="page-rnr-main-btn-before lastStep" round @click="handleToBefore">{{ convertLanage('上一步') }}</van-button>
      <van-button :disabled="btnDisable" type="primary" class="page-rnr-main-btn-next" round color="linear-gradient(120deg, #000 0%, #000 97%)" @click="handleToNext">{{ convertLanage('下一步') }}</van-button>
    </template>
  </Page>
</template>

<script>
import Page from '@/components/Page'
import ErrorWrap from '@/components/ErrorWrap'
import BridgeUpload from '@/components/BridgeUpload'
import { fileUpload } from '@/api/markup'
import { Toast } from 'vant'
import { validate } from '@/utils/validate'
import { SET_PERSON_FILE } from '@/store/modules/markup'
import flowMixin from '@/minxin/flow'
import { convertLanage } from '@/utils/lanage'

export default {
  name: 'MarkupPersonCard',
  components: { Page, BridgeUpload, ErrorWrap },
  mixins: [flowMixin],
  data() {
    return {
      inputError: {},
      countTime: 59,
      isSend: false,
      showSms: false,
      formData: {
        purchaseContractPic: [],
        purchaseInvoicePic: [],
        transferCertificatePic: []
      }
    }
  },
  computed: {
    /**
     * 按钮是否禁用
     */
    btnDisable() {
      const { transferCertificatePic, purchaseContractPic } = this.formData
      return transferCertificatePic.length === 0 || purchaseContractPic.length === 0
    }
  },
  methods: {
    /**
     * 简繁体语言转换
     */
    convertLanage(strs) {
      return convertLanage(strs)
    },
    /**
     * 删除文件
     */
    handleDeleteFile(files, { index }, key) {
      this.formData[key].splice(index, 1)
    },

    /**
     * 上传文件
     * @param origin 源文件
     * @param key 字段key
     */
    handleUploadFile(origin, key) {
      // 获取当前文件
      let files = origin
      // 如果当前不是数组，则将其变成数组
      if (!(files instanceof Array)) {
        files = [files]
      }
      // 将文件的uuid都展示在界面上
      files.forEach(async file => {
        // 文件可访问路径和文件的uuid
        const { uuid } = await fileUpload({ file: file.content })
        // 将文件id保存在照片中
        this.formData[key].push(uuid)
        // 开始校验上传字段
        this.validate([key])
      })
    },

    /**
     * 调到到下一页：签名页
     */
    async handleToNext() {
      // 校验不通过的字段
      const failField = this.validate(['purchaseContractPic', 'purchaseInvoicePic', 'transferCertificatePic'])
      // 如果当前校验失败
      if (failField) {
        return
      }
      // 将当前数据保存到store中
      this.$store.commit(`markup/${SET_PERSON_FILE}`, this.formData)
      // 跳转页面
      this.routerToNextPage('MarkupPersonNotification')
    },

    /**
     * 校验用户输入
     */
    validate(ruleKeys) {
      // 错误的字段，错误的信息
      const [failField, failMessage] = validate(this.formData, ruleKeys)
      // 如果当前有错误信息
      ruleKeys.forEach(key => {
        this.$set(this.inputError, key, failField === key ? failMessage : '')
      })
      return failField
    },

    /**
     * 跳转到上一页
     */
    handleToBefore() {
      // 回退到上个页面
      this.$router.back()
    },

    /**
     * 图片超过最大限制
     */
    handleOverSize() {
      Toast(convertLanage('选择的图片超过最大限制，请重新选择'))
    }
  }
}
</script>

<style lang="scss">
.page-rnr-person-file {
  .page-rnr-main {
    margin-top: 0px;
  }
  .page-rnr-main-fixed-btn-group {
    display: flex;
    justify-content: space-between;
    .page-rnr-main-btn-before {
      color: #242424 !important;
      flex: 1;
      height: 96px;
    }
    .page-rnr-main-btn-next {
      flex: 2;
      margin-left: 40px;
      height: 96px;
    }
  }
  .icon-upload-camera {
    background-image: url(../../../assets/rnr/ico_camera.png);
    background-size: 100% 100%;
    position: absolute;
    width: 80px;
    height: 80px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .page-rnr-main-card-upload-normal {
    background-image: url(../../../assets/rnr/ico_pic.png);
    background-color: #F7F8FA;
    background-size: 196px 196px;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 8px;
    width: 196px;
    height: 196px;
  }
  .page-rnr-main-btn {
    font-size: 32px !important;
    &.disabled {
      color: #CACACA !important;
    }
  }
  .van-cell__label {
    .page-rnr-flex {
      display: flex;
      justify-content: space-between;
    }
  }
  .page-rnr-person-file-tip {
    font-size: 24px;
    color: rgba(255, 255, 255, 0.6);
    font-weight: 400;
    padding: 14px 48px 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/markup/person/file.vue